var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrderStatus',{attrs:{"order-no":"YBDF202038DHHD99999231823919238741294","total-amount":30000,"tips":"项目标段开标后，支持在线申请保费发票及下载电子保单","status-text":"已完成","time":Date.now()}},[_c('template',{slot:"operate"},[_c('a-button',{staticClass:"btn",attrs:{"type":"primary"}},[_vm._v(" 下载保单 ")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }